import io, { Socket } from 'socket.io-client';

import { optionalEnv } from '../utils/env';
import LS from '../utils/localStorageUtils';

const DUELS_NAMESPACE = '/duels';
const DUELS_SOCKET_PATH = '/duels-socket.io';

let duelsSocket: Socket | null = null;

function duelsSocketUrl(raw: string): string {
	let trimmed = raw.trim().replace(/\/$/, '');
	if (trimmed.startsWith('ws://')) {
		trimmed = `http://${trimmed.slice('ws://'.length)}`;
	} else if (trimmed.startsWith('wss://')) {
		trimmed = `https://${trimmed.slice('wss://'.length)}`;
	}
	return trimmed.endsWith(DUELS_NAMESPACE) ? trimmed : `${trimmed}${DUELS_NAMESPACE}`;
}

export function openDuelsSocket(): Socket | null {
	if (duelsSocket) return duelsSocket;

	const url = optionalEnv('DUELS_WS_URL');
	if (!url) return null;

	duelsSocket = io(duelsSocketUrl(url), {
		path: DUELS_SOCKET_PATH,
		auth: callback => callback({ token: LS.get('access_token') }),
		reconnection: true,
		reconnectionAttempts: Infinity,
		reconnectionDelay: 1000,
		reconnectionDelayMax: 5000,
		timeout: 20000,
		autoConnect: false,
	});
	return duelsSocket;
}

export function closeDuelsSocket() {
	if (!duelsSocket) return;

	duelsSocket.removeAllListeners();
	duelsSocket.disconnect();
	duelsSocket = null;
}
